<template>
  <component v-bind:is="Componente" />
</template>

<script>
const requireViews = require.context('@/views', true, /\.vue$/)

export default {
  name: 'VersaoLoader',
  props: {
    path: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      Componente: null
    }
  },
  mounted () {
    const caminho = `./${this.$bancodofuturo}/${this.path}.vue`

    if (requireViews.keys().includes(caminho)) {
      this.Componente = requireViews(caminho).default
    } else {
      this.Componente = () => import('@/views/FallbackVersao.vue')
    }
  }
}
</script>
